import styled from 'styled-components';

import { coolGrey1 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { skeletonState } from 'approot/shared/styles/transitions.style';

type ActivitiesPreviewButtonProps = {
  ratio?: number;
};

export const ActivitiesPreviewButton = styled.div<ActivitiesPreviewButtonProps>`
  ${skeletonState}
  background-color: ${coolGrey1};
  border-radius: ${rem(borderRadius8)};
  flex-grow: 1;

  &::before {
    content: '';
    width: 1px;
    margin-left: -1px;
    float: left;
    height: 0;
    padding-top: ${({ ratio }) => (ratio ? ratio : '100')}%;
  }
  &::after {
    content: '';
    display: table;
    clear: both;
  }
`;
